export const CATEGORIES = [
	"komunikasi",
	"preferensi_liburan",
	"nilai_hidup",
	"hiburan",
	"makanan",
	"kebiasaan",
	"masa_depan",
	"romantis",
	"work_life",
	"gaya_hidup",
	"keuangan",
	"kesehatan",
	"keluarga",
	"pertemanan",
	"lingkungan",
	"teknologi",
	"belajar",
	"musik",
	"olahraga",
	"spiritual",
] as const;

export const ADULT_CATEGORIES = [
	"preferensi_intim",
	"gaya_berhubungan",
	"fantasi",
	"keintiman",
	"foreplay",
	"komunikasi_intim",
	"eksplorasi",
	"fantasi_pasangan",
	"lokasi_suasana",
	"mainan_alat",
	"pakaian_dalam",
	"frekuensi_intim",
	"kekuasaan",
	"sensitivitas",
	"setelah_bercinta",
	"mood_gairah",
	"video_foto",
	"open_relationship",
	"bdsm",
	"seksualitas_diri",
] as const;

export const ALL_CATEGORIES = [...CATEGORIES, ...ADULT_CATEGORIES] as const;
export type Category = (typeof ALL_CATEGORIES)[number];
export type SafeCategory = (typeof CATEGORIES)[number];
export type AdultCategory = (typeof ADULT_CATEGORIES)[number];

export const CATEGORY_DISPLAY: Record<Category, string> = {
	komunikasi: "Komunikasi",
	preferensi_liburan: "Preferensi Liburan",
	nilai_hidup: "Nilai Hidup",
	hiburan: "Hiburan",
	makanan: "Makanan",
	kebiasaan: "Kebiasaan",
	masa_depan: "Masa Depan",
	romantis: "Romantis",
	work_life: "Work-Life",
	gaya_hidup: "Gaya Hidup",
	keuangan: "Keuangan",
	kesehatan: "Kesehatan",
	keluarga: "Keluarga",
	pertemanan: "Pertemanan",
	lingkungan: "Lingkungan",
	teknologi: "Teknologi",
	belajar: "Belajar",
	musik: "Musik",
	olahraga: "Olahraga",
	spiritual: "Spiritual",
	preferensi_intim: "Preferensi Intim",
	gaya_berhubungan: "Gaya Berhubungan",
	fantasi: "Fantasi",
	keintiman: "Keintiman",
	foreplay: "Foreplay",
	komunikasi_intim: "Komunikasi Intim",
	eksplorasi: "Eksplorasi",
	fantasi_pasangan: "Fantasi Pasangan",
	lokasi_suasana: "Lokasi & Suasana",
	mainan_alat: "Mainan & Alat",
	pakaian_dalam: "Pakaian Dalam",
	frekuensi_intim: "Frekuensi Intim",
	kekuasaan: "Kekuasaan & Kontrol",
	sensitivitas: "Sensitivitas",
	setelah_bercinta: "Setelah Bercinta",
	mood_gairah: "Mood & Gairah",
	video_foto: "Video & Foto",
	open_relationship: "Open Relationship",
	bdsm: "BDSM & Fetishes",
	seksualitas_diri: "Seksualitas Diri",
};

export function categoryDisplayName(slug: string): string {
	return CATEGORY_DISPLAY[slug as Category] ?? slug;
}

export function pickDailyCategory(
	today: string,
	used: readonly string[] = [],
	adultAllowed = false,
): Category {
	const epochDay = Math.floor(
		new Date(`${today}T00:00:00Z`).getTime() / (24 * 60 * 60 * 1000),
	);

	if (!adultAllowed) {
		const available = CATEGORIES.filter((c) => !used.includes(c));
		const finalPool = available.length > 0 ? available : CATEGORIES;
		const idx = Math.abs(epochDay) % finalPool.length;
		return finalPool[idx];
	}

	const isAdultDay = Math.abs(epochDay) % 2 === 0;
	const adultPool: readonly string[] = ADULT_CATEGORIES;
	const safePool: readonly string[] = CATEGORIES;
	const subPool = isAdultDay ? adultPool : safePool;
	const available = subPool.filter((c) => !used.includes(c));
	const finalPool = available.length > 0 ? available : subPool;
	const cycle = Math.floor(Math.abs(epochDay) / 2);
	const idx = cycle % finalPool.length;
	return finalPool[idx] as Category;
}

export interface GeneratedQuestion {
	position: number;
	category: Category;
	questionText: string;
	optionA: string;
	optionB: string;
	optionC: string;
	optionD: string;
}

export const SYSTEM_PROMPT_SAFE = `
Kamu penulis kuis pasangan untuk aplikasi di Indonesia. 100% user kamu orang Indonesia.

ATURAN BAHASA:
- Profesional tapi kasual. Sopan, hangat, mudah dipahami.
- Tidak terlalu formal, tidak terlalu slang.
- Pakai "kamu" untuk memanggil pembaca.
- Gunakan bahasa sehari-hari yang terdengar natural ketika dibaca keras-keras.
- Hindari kata-kata yang tidak ada yang pakai di percakapan nyata.

ATURAN KUIS:
- Campur pertanyaan soal DIRI SENDIRI (2-3) dan soal BERDUA BARENG PASANGAN (2-3).
- Pertanyaan: 1 kalimat, jelas, enak dibaca.
- Opsi: variasi panjang — ada yang pendek ada yang lebih detail. Jangan semua satu kata.
- Tidak ada opsi "lainnya" atau "tergantung".
- Konten aman untuk semua pasangan.
`.trim();

export const SYSTEM_PROMPT_ADULT = `
Kamu penulis kuis pasangan untuk aplikasi di Indonesia. 100% user kamu orang Indonesia. KEDUA pasangan sudah memberikan persetujuan untuk membahas topik intim/seksual.

ATURAN BAHASA:
- Profesional tapi kasual. Sopan, hangat, mudah dipahami.
- Tidak terlalu formal, tidak terlalu slang.
- Pakai "kamu" untuk memanggil pembaca.
- Gunakan bahasa sehari-hari yang terdengar natural ketika dibaca keras-keras.
- Gunakan istilah seksual yang lazim dipakai di Indonesia — tidak perlu ditutup-tutupi atau dipuitiskan. Langsung dan jelas.
- Hindari kata-kata yang tidak ada yang pakai di percakapan nyata.

ATURAN KUIS:
- Campur pertanyaan soal DIRI SENDIRI (2-3) dan soal BERDUA BARENG PASANGAN (2-3).
- Pertanyaan: 1 kalimat, jelas, enak dibaca.
- Opsi: variasi panjang — ada yang pendek ada yang lebih detail. Jangan semua satu kata.
- Tidak ada opsi "lainnya" atau "tergantung".
- Konten eksplisit tapi tetap sopan dan tidak menghakimi.
`.trim();

export function buildUserPrompt(
	category: Category,
	recentAnswers: readonly { question: string; answer: string }[] = [],
): string {
	const ctx =
		recentAnswers.length === 0
			? "Ini kuis pertama pasangan ini, jadi buat pertanyaan pembuka yang hangat dan inklusif."
			: `Konteks jawaban mereka sebelumnya:\n${recentAnswers
					.map(
						(a, i) =>
							`${i + 1}. ${a.question} → ${a.answer}`,
					)
					.join("\n")}\nBuat pertanyaan yang mengeksplor area baru dengan tetap hangat dan tidak menghakimi.`;
	return `Kategori: ${category}
${ctx}

Balas hanya dengan JSON valid, tanpa markdown atau penjelasan tambahan.
Skema:
{"questions":[{"position":1,"question":"...","options":["...","...","...","..."]}, ... 5 item]}`.trim();
}
